import { isNumber } from 'lodash';
import { useMemo } from 'react';
import { useGlobalContext } from '../components/global';
export function useColorString(color) {
    var convertThemeString = useGlobalContext().convertThemeString;
    return useMemo(function () { return convertThemeString(color); }, [convertThemeString, color]);
}
var BORDER_RADIUS_PREDEFINED = {
    normal: '0.3rem',
};
export function useBorderRadius(value) {
    return useMemo(function () {
        if (isNumber(value)) {
            if (value === 0) {
                return '0';
            }
            return value + "px";
        }
        if (BORDER_RADIUS_PREDEFINED.hasOwnProperty(value)) {
            // @ts-ignore
            return BORDER_RADIUS_PREDEFINED[value];
        }
        return value;
    }, []);
}
//# sourceMappingURL=useCSSStrings.js.map